import React, { useState } from 'react'
import styles from './SolutionsSection.module.css'
import { useLang } from '../../i18n/LanguageContext'

const SOLUTION_META = [
  { id: 'hoc',  tag: 'SIGEC HOC',  color: '#2E3192', accent: '#3D4499' },
  { id: 'web',  tag: 'SIGEC WEB',  color: '#1B1F3B', accent: '#2E3192' },
  { id: 'elos', tag: 'SIGEC ELOS', color: '#F47E2F', accent: '#FF9A4D', highlight: true },
  { id: 'bc',   tag: 'BC REPORT',  color: '#00BFA5', accent: '#008F7A' },
  { id: 'mobi', tag: 'MOBI',       color: '#1B1F3B', accent: '#2E3192' },
  { id: 'coa',  tag: 'COA',        color: '#0F1128', accent: '#1B1F3B' },
]

export default function SolutionsSection() {
  const { T } = useLang()
  const [expanded, setExpanded] = useState(null)

  return (
    <section className={`section ${styles.solutions}`} id="solucoes">
      <div className="container">
        <div className={styles.header}>
          <p className="section-label">{T.solutions.label}</p>
          <h2 className="section-title section-title--light">
            {T.solutions.heading1}
            <br />
            {T.solutions.heading2}
          </h2>
          <p className="section-desc section-desc--light">{T.solutions.desc}</p>
        </div>

        <div className={styles.grid}>
          {SOLUTION_META.map((meta, i) => {
            const card = T.solutions.cards[i]
            return (
              <div
                key={meta.id}
                className={`${styles.card} ${meta.highlight ? styles.cardHighlight : ''} ${expanded === meta.id ? styles.cardOpen : ''}`}
                style={{ '--card-color': meta.color, '--card-accent': meta.accent }}
                onClick={() => setExpanded(expanded === meta.id ? null : meta.id)}
              >
                <div className={styles.cardTop}>
                  <span className={styles.cardTag}>{meta.tag}</span>
                  <svg
                    className={styles.cardArrow}
                    width="18" height="18" viewBox="0 0 18 18" fill="none"
                    style={{ transform: expanded === meta.id ? 'rotate(180deg)' : 'none' }}
                    aria-hidden="true"
                  >
                    <path d="M4.5 7 L9 11.5 L13.5 7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>

                <h3 className={styles.cardTitle}>{card.title}</h3>
                <p className={styles.cardDesc}>{card.desc}</p>

                {expanded === meta.id && (
                  <ul className={styles.featureList}>
                    {card.features.map((f) => (
                      <li key={f} className={styles.featureItem}>
                        <span className={styles.featureDot} aria-hidden="true" />
                        {f}
                      </li>
                    ))}
                  </ul>
                )}

                {meta.id === 'elos' && (
                  <a
                    href="https://elos.eqpitech.com.br"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.cardCta}
                    onClick={(e) => e.stopPropagation()}
                  >
                    {T.solutions.elosAccess}
                  </a>
                )}
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}
